var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeatherIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.592,
    height: 33.604,
    viewBox: "0 0 33.592 33.604",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cloudy",
    transform: "translate(-0.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M177.422,80.543A8.543,8.543,0,1,1,168.879,72,8.543,8.543,0,0,1,177.422,80.543Zm0,0",
    transform: "translate(-148.458 -66.874)",
    fill: "#fdb020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M272.905,3.417a.569.569,0,0,1-.57-.57V.57a.57.57,0,1,1,1.139,0V2.848A.57.57,0,0,1,272.905,3.417Zm0,0",
    transform: "translate(-252.484)",
    fill: "#fdd020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M427.184,185.139h-2.278a.57.57,0,1,1,0-1.139h2.278a.57.57,0,0,1,0,1.139Zm0,0",
    transform: "translate(-393.663 -170.9)",
    fill: "#fdd020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M27.256,191.448a6.279,6.279,0,0,0-1.241.124,5.116,5.116,0,0,0-7.166-3.638A6.829,6.829,0,1,0,6.012,192.6a5.693,5.693,0,0,0,.171,11.382H27.256a6.265,6.265,0,0,0,0-12.53Zm0,0",
    transform: "translate(0 -170.375)",
    fill: "#6bb7f8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_472",
    "data-name": "Group 472",
    transform: "translate(9.593 2.841)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M138.614,50.278,136.336,48",
    transform: "translate(-135.759 -47.423)",
    fill: "#fdd020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M131.091,43.326a.569.569,0,0,1-.4-.167l-2.278-2.278a.57.57,0,1,1,.805-.805l2.278,2.278a.57.57,0,0,1-.4.972Zm0,0",
    transform: "translate(-128.236 -39.902)",
    fill: "#fdd020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M392.336,50.278,394.614,48",
    transform: "translate(-373.534 -47.423)",
    fill: "#fdd020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M384.905,43.326a.57.57,0,0,1-.4-.972l2.278-2.278a.57.57,0,1,1,.805.805l-2.278,2.278A.57.57,0,0,1,384.905,43.326Zm0,0",
    transform: "translate(-366.103 -39.902)",
    fill: "#fdd020"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherIcon);
export default __webpack_public_path__ + "static/media/weatherIcon.ababbb5de2984f2f7ab52c7c23fc2818.svg";
export { ForwardRef as ReactComponent };